/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import type { StrapiEnterpriseHero } from "@/types/strapi";

import { spacingSets } from "@/tokens/configs/spacing_config";
import { Spacing } from "@/tokens/spacing";

import { Button } from "@/ui/atoms/button";
import { GridColumn } from "@/ui/atoms/grid_column";
import { GridContainer } from "@/ui/atoms/grid_container";
import { Text } from "@/ui/atoms/text";

import { mapButtonAppearance } from "@/util/button_util";
import { buildStylesByBreakpoint } from "@/util/style_util";
import { getSectionGap } from "@/util/tokens/layout_util";

export function EnterpriseHero(props: StrapiEnterpriseHero) {
    /**
     * Styles
     */

    const containerStyles = buildStylesByBreakpoint(
        "rowGap",
        spacingSets.DefaultPageHeroRowGap,
    );

    const subheadlineStyles = css({
        marginTop: Spacing["spacing-4"],
    });

    const buttonGroupStyles = css({
        columnGap: Spacing["spacing-4"],
        display: "flex",
        justifyContent: "center",
    });

    return (
        <GridContainer
            className={containerStyles}
            legacyGrid={false}
            marginBottom={getSectionGap(props.Section_Gap)}
            marginTop="DefaultPageHeroTop"
        >
            <GridColumn
                columnSpan={{
                    extraSmall: "full",
                    medium: 8,
                }}
                columnStart={{
                    extraSmall: 1,
                    medium: 3,
                }}
            >
                <Text fontSize="HeadlineDefault" tag="h1" textAlign="center">
                    {props.Headline}
                </Text>

                <Text
                    className={subheadlineStyles}
                    shouldBalanceWrap={true}
                    textAlign="center"
                    themeKey="textPrimary"
                >
                    {props.Subheadline}
                </Text>
            </GridColumn>

            <GridColumn className={buttonGroupStyles}>
                {props.Primary_Action.map((action) => (
                    <Button
                        href={action.URL}
                        key={action.id}
                        variant={mapButtonAppearance(action.Appearance)}
                    >
                        {action.Text}
                    </Button>
                ))}
            </GridColumn>
        </GridContainer>
    );
}
